export default "__VITE_ASSET__Bw$8AE6k__"